import Image from "../Image/Image";
import Userdatafilledpopup from "./UserdetailPopup";
import { useState } from "react";
import classesCSS from "./Tabs.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { appNavigateTo } from "../../../store/actions/navActions";
import { useAppContent } from "../../../shared/AppContent";
import { trackPages } from "../../../shared/utility";
import { getOracleCTAClick } from "../../../shared/AdobeUtility";

const Tabs = ({
  extraDetails,
  getSection,
  classes,
  clickable = false,
  userDetail,
}) => {
  const AppState = useSelector((state) => state.AppState);
  const landingScreen = AppState?.screenName;
  const isDumpBased = useSelector((state) => state?.DumpData?.isDumpData);

  const handleClick = (state) => {
    trackPages("tracking_11");
    trackPages("tracking_12");
    if(landingScreen === 'city' && isDumpBased){
      dispatch(appNavigateTo({ goTo: "pan" }, "APP_NAVIGATE_TO"));
    }
    else{
    dispatch(appNavigateTo({ goTo: landingScreen }, "APP_NAVIGATE_TO"));
    }
  };
  const { cardTilePageContent } = useAppContent();
  const [isOpen, setIsOpen] = useState(false);
  const [tabName, setTabName] = useState("");
  const dispatch = useDispatch();
  const handlePopUp = (selectedTabName) => {
    setTabName(selectedTabName);
    // userDetail?.firstName?.length > 0 && extraDetails ? 
    setIsOpen((isOpen) => !isOpen)
    // : handleClick();
  };
  const handlePopUpProf = (selectedTabName) => {
    setTabName(selectedTabName);
    // userDetail?.occupation?.length > 0 && extraDetails ?
    setIsOpen((isOpen) => !isOpen)
    // : handleClick();
  };

  const handlePopUpKYC = (selectedTabName) => {
    setTabName(selectedTabName);
    // (userDetail?.resiAddr?.pin?.length > 0 || userDetail?.resiAddr[0]?.pin?.length > 0 || userDetail?.photoMatchStatus) && extraDetails ? 
    setIsOpen((isOpen) => !isOpen)
    // : handleClick();
  }

  var onKycDetails = getSection !== "personalDetails" && getSection !== "professionalDetails";
  var onProfessionalDetails = getSection === "professionalDetails";
  var onPersonalDetails = getSection === "personalDetails";


  return ( 
    <>
      <div
        className={`${classes.Footer} ${getSection !== "personalDetails" ? classes.ReversOrder : ""
          }`}
      >
        <button
          className={`${classes.PersonalDetailsSection} 
        ${getSection === "personalDetails" ? classes.ActiveSection : ""}
        ${clickable && classes.ActivePanel}`}
          onClick={() => {
            getOracleCTAClick("personal-details", AppState, "Form Start");
            if (onPersonalDetails)
              handleClick()
            else
              handlePopUp("personalDetails")
          }}
        // onClick={() => handlePopUp("personalDetails")}
        >
          <div className={classes.SectionWrapper}>
            <span className={classes.SectionContent}>
              {cardTilePageContent?.step_tiles?.personal_detail?.heading}
            </span>
            {extraDetails && (
              <>
                <div className={`${window.innerWidth < 768 && !onPersonalDetails ? classes.HideNameDetails : ""}`}>{cardTilePageContent?.step_tiles?.personal_detail?.text}</div>
                {!onPersonalDetails ?
                  <div
                    className={classes.VSummaryBTN}
                  >
                    <span>View Summary</span>
                    <Image
                      className={classes.Image}
                      filename={"arrow_forward_black-2"
                      }
                      renditions={["2x"]}
                      ext={"png"}
                    />
                  </div> : null}
              </>

            )}
          </div>
          <div>
            {extraDetails && (
              <div
                onClick={() => handleClick()}
                className={
                  onPersonalDetails
                    ? classes.GoToImage
                    : classes.GoToImage + " " + classes.Completed
                }
              >
                <Image
                  filename={onPersonalDetails ? "Path -3" : "Group630"}
                  ext="png"
                  renditions={["2x"]}
                  alt=""
                />
              </div>
            )}
            {extraDetails && window.innerWidth > 768 && (
              <Image
                className={classes.SectionImg}
                filename={"Mask Group 6"}
                ext="png"
                renditions={["2x"]}
                alt=""
              />
            )}
            {!extraDetails && (
              <Image
                className={classes.SectionImg}
                filename={onPersonalDetails ? "Group449" : "Group630"}
                ext="png"
                renditions={["2x"]}
                alt=""
              />
            )}
          </div>
        </button>
        <button
          className={`${classes.ProfessionalDetailsSection} ${onProfessionalDetails ? classes.ActiveSection : ""
            } ${onProfessionalDetails || onKycDetails ? classesCSS.cursorPointer : ""
            }`}
          disabled={onPersonalDetails}
          onClick={() => {
            if (onProfessionalDetails)
              handleClick()
            else
              handlePopUpProf("professionalDetails")
          }}
        // onClick={() => handlePopUpProf("professionalDetails")}
        >
          <div className={classes.SectionWrapper}>
            <span className={classes.SectionContent}>
              {cardTilePageContent?.step_tiles?.professional_detail?.heading}
            </span>
            {extraDetails && (
              <>
                <div className={`${window.innerWidth < 768 && !onProfessionalDetails && userDetail?.occupation?.length > 0 ? classes.HideProfDetails : ""}`}>
                  {cardTilePageContent?.step_tiles?.professional_detail?.text}
                </div>
                {
                  userDetail?.firstName && userDetail.occupation && !onProfessionalDetails ?
                    <div
                      className={classes.VSummaryBTN}
                    >
                      <span>View Summary</span>
                      <Image
                        className={classes.Image}
                        filename={"arrow_forward_black-2"
                        }
                        renditions={["2x"]}
                        ext={"png"}
                      />
                    </div> :
                    null
                }
              </>
            )}
          </div>
          <div>
            {extraDetails && (onKycDetails || onProfessionalDetails) && (
              <div
                onClick={() => handleClick()}
                className={
                  onKycDetails
                    ? classes.GoToImage + " " + classes.Completed
                    : classes.GoToImage
                }
              >
                <Image
                  filename={onKycDetails ? "Group630" : "Path -3"}
                  ext="png"
                  renditions={["2x"]}
                  alt=""
                />
              </div>
            )}

            {extraDetails && <Image
              className={window.innerWidth > 768 ? classes.SectionImg : !onPersonalDetails ? classes.NoSectionImg : classes.SectionImg}
              filename={window.innerWidth > 768 ? "Mask Group 7" : "Path1223"}
              ext="png"
              renditions={["2x"]}
              alt=""
            />
            }
            {!extraDetails && <Image
              className={
                classes.SectionImg

              }
              filename={onKycDetails ? "Group630" : "Path1223"}
              ext="png"
              renditions={["2x"]}
              alt=""
            />}
          </div>
        </button>

        {/* kyc details popup */}
        <button
          // onClick={() => handlePopUpKYC("kycDetails")}
          className={`${classes.KycDetailsSection} ${onKycDetails ? classes.ActiveSection : ""
            }`}
          disabled={onPersonalDetails || onProfessionalDetails}
          onClick={() => {
            if (onKycDetails)
              handleClick()
            else
              handlePopUpKYC("kycDetails")
          }}
        >
          <div className={classes.SectionWrapper}>
            <span className={classes.SectionContent}>
              {cardTilePageContent?.step_tiles?.kyc_details?.heading}
            </span>
            {extraDetails && (
              <>
                <div className={`${window.innerWidth < 768 &&
                  !onKycDetails &&
                  (userDetail?.resiAddr?.pin || (userDetail?.resiAddr && userDetail?.resiAddr[0]?.pin) || userDetail?.photoMatchStatus) ? classes.HideKycDetails : ""}`}>{cardTilePageContent?.step_tiles?.kyc_details?.text}</div>
                {/* {(userDetail?.resiAddr?.pin || (userDetail?.resiAddr && userDetail?.resiAddr[0]?.pin) || userDetail?.photoMatchStatus) ?
                  <div
                    className={classes.VSummaryBTN}
                    onClick={() => handlePopUpKYC("kycDetails")}
                  >
                    <span>View Summary</span>
                    <Image
                      className={classes.Image}
                      filename={"arrow_forward_black-2"
                      }
                      renditions={["2x"]}
                      ext={"png"}
                    />
                  </div> : null} */}
              </>
            )}
          </div>
          {onKycDetails && extraDetails && (
            <div onClick={() => handleClick()} className={classes.GoToImage}>
              <Image
                filename={"Path -3"}
                ext="png"
                renditions={["2x"]}
                alt=""
              />
            </div>
          )}
          {(!onKycDetails || window.innerWidth > 768) && (
            <Image
              className={classes.SectionImg}
              filename={
                extraDetails && window.innerWidth > 768
                  ? "Mask Group 8"
                  : "Group451"
              }
              ext="png"
              renditions={["2x"]}
              alt=""
            />
          )}
        </button>
      </div>
      {isOpen && (
        <Userdatafilledpopup
          classesCSS={classesCSS}
          userDetail={userDetail}
          handlePopUp={handlePopUp}
          tabName={tabName}
        />
      )}
    </>
  );
};

export default Tabs;
